import { render, staticRenderFns } from "./TifReporteConsolidadoViajes.vue?vue&type=template&id=542da6c3"
import script from "./TifReporteConsolidadoViajes.vue?vue&type=script&lang=js"
export * from "./TifReporteConsolidadoViajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports